import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { useHomeContext } from "../contexts/HomeContextProvider";
import { readData } from "../firebase/auth";

export const useSyncParamsId = () => {
  const { divisionId } = useParams();
  const { setDivisionEventData } = useHomeContext();
  const navigate = useNavigate();

  async function checkEventExists(divisionId) {
    let res = await readData(`/divisions/${divisionId}`);
    if (res && res.enable && res.currentEventId) {
      const obj = {
        divisionId: divisionId,
        currentEventId: res.currentEventId,
        currentDivision: res,
        currentEventData: res["events"][res.currentEventId],
      }
      setDivisionEventData(obj);
    } else {
      navigate("/", { replace: true });
    }
  }

  useEffect(() => {
    if (divisionId) {
      checkEventExists(divisionId.toLowerCase());
    }
  }, [divisionId]);
};
